import React, { createContext, useContext, useState } from 'react';
import { industries } from '../data/industryDataService';

const IndustryContext = createContext();

export function IndustryProvider({ children }) {
  const [selectedIndustry, setSelectedIndustry] = useState(
    industries.includes('Technology & SaaS') ? 'Technology & SaaS' : industries[0]
  );
  return (
    <IndustryContext.Provider value={{ selectedIndustry, setSelectedIndustry, industries }}>
      {children}
    </IndustryContext.Provider>
  );
}

export function useIndustry() {
  const context = useContext(IndustryContext);
  if (!context) throw new Error('useIndustry must be used within IndustryProvider');
  return context;
}
